<img *ngIf="productLogoSrc" class="logo product" height="10" [src]="productLogoSrc">

<div class="content">
  <ng-content></ng-content>
</div>

<img class="logo systematic" height="10" src="assets/cui/logo/systematic-white.svg" alt="SYSTEMATIC">



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/core/background/background.component.html